import { useLocation, useNavigate } from "react-router"
import bhumeet from "../../../assets/bhumeet.svg"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import Loading from "../../../ReusableFunctions/Loader"
import Popup from "../../../ReusableFunctions/Popup"
import dateFormat from 'dateformat';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import dashLine from "../../../assets/dashLine.svg"
import { formatToIndianRupees } from "../../../ReusableFunctions/reusableFunctions"
import { DSP_INVOICES_TYPES, SETTELEMENT_STATUSES } from "../../../appConstants"
import { geDspLeadInvoiceDetails } from "../../../apis/settlements"
import { useSelector } from "react-redux"
import TableView from "../../../ReusableComponents/TableView/TableView"

const DspLeadInvoiceDetails = () => {
    const user = useSelector(state => state.user?.user)
    const location = useLocation();
    const navigate = useNavigate();
    const tableContainerRef = useRef(null);
    const termsRef = useRef(null);
    const termsWrapperRef = useRef(null);
    const [placeTermsOnNextPage, setPlaceTermsOnNextPage] = useState(false);

    const { dsp, invoice } = location.state || {};
    console.log('invoice: ', invoice);

    const queryParams = new URLSearchParams(location.search);
    const paymentStatus = queryParams.get("razorpay_payment_link_status");

    const [settInvoice, setSettInvoice] = useState({})
    const [requests, setRequests] = useState([])
    const [isDownload, setIsDownload] = useState(false)

    const splitArrayIntoChunks = (array, chunkSize) => {
        let result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };

    const calculateTermsPadding = (requestsLength) => {
        if (!isDownload) return "0px";

        const requestsPerPage = 24;
        const totalRequestPages = Math.ceil(requestsLength / requestsPerPage);

        const rowsOnLastPage = requestsLength % requestsPerPage || requestsPerPage;
        const lastPageContentHeight = (rowsOnLastPage * 30) + 60;
        const pageHeight = 1120;
        const remainingSpace = pageHeight - lastPageContentHeight - 350;
        if (remainingSpace > 250) {
            return "80px";
        } else {
            return "200px";
        }
    };

    const getSettelementInvoiceDetailsFunc = async (id) => {
        try {
            Loading.set(true)
            const settleInvoice = await geDspLeadInvoiceDetails(id);
            console.log('settleInvoice: ', settleInvoice);
            const requestsData = settleInvoice?.requests ? settleInvoice?.requests.map((req) => ({ ...req, price_per_lead : settleInvoice?.price_per_lead || 100 })) : [];

            const splitRequests = splitArrayIntoChunks(requestsData, 16);
            setRequests(requestsData);

            setSettInvoice({
                ...settleInvoice,
                time: new Date(settleInvoice?.time),
                invoice_id: invoice?.id,
                generated_time: new Date(settleInvoice?.generated_time),
                to_bank_account_name: settleInvoice?.dsp_bank_account?.bank_name,
                to_bank_account_ifsc: settleInvoice?.dsp_bank_account?.ifsc_code,
                to_bank_account_number: settleInvoice?.dsp_bank_account?.account_no,
                to_bank_account_holder_name: settleInvoice?.dsp_bank_account?.account_holder_name,
                requestsChunks: splitRequests
            });
            Loading.set(false)
        } catch (error) {
            Loading.set(false)
            Popup.alert("Error", error, "ERROR")
        }
    }

    const wait = async () => {
        return new Promise((resolve) => {
            setTimeout(resolve, 0)
        })
    }



    const downloadPDF = async () => {
        setIsDownload(true);
        Loading.set(true)

        if (requests.length > 0) {
            const splitArray1 = splitArrayIntoChunks(requests, 24);
            setSettInvoice((prev) => ({
                ...prev,
                requestsChunks: splitArray1
            }))
        }

        await wait(); // Assuming wait() is some delay or other asynchronous task
        const input = document.querySelector('.myDiv');

        html2canvas(input, {
            scale: 1.5,
            useCORS: true,
            backgroundColor: null,
        }).then(canvas => {
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Proportional image height
            let heightLeft = imgHeight;

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true,
            });

            let position = 0; // Position on the first page
            let pageCount = 1;
            pdf.setFontSize(10);

            // Add the first image
            const imgData = canvas.toDataURL('image/png', 0.8); // 80% quality

            pdf.addImage(
                imgData,
                'PNG',
                0,
                position,
                imgWidth,
                imgHeight
            );
            heightLeft -= pageHeight; // Subtract page height from image height
            pdf.text(`Page ${pageCount}`, 100, 290);

            // Add new pages if there's more content
            while (heightLeft > 0) {
                position = heightLeft - imgHeight; // Update position for next page
                pdf.addPage(); // Add new page
                pdf.addImage(
                    imgData,
                    'PNG',
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );
                pageCount++
                pdf.text(`Page ${pageCount}`, 100, 290);
                heightLeft -= pageHeight; // Subtract again for the next page
            }

            pdf.save('invoice.pdf');

            if (requests.length > 0) {
                const splitArray2 = splitArrayIntoChunks(requests, 16);
                setSettInvoice((prev) => ({
                    ...prev,
                    requestsChunks: splitArray2
                }))
            }

            setIsDownload(false);
            Loading.set(false);
        });
    };


    useEffect(() => {
        const refId = queryParams.get("razorpay_payment_link_reference_id");
        console.log('refId: ', refId);

        if (refId) {
            // call API using reference_id instead of invoice.id
            getSettelementInvoiceDetailsFunc(refId);
        } else if (invoice?.id) {
            getSettelementInvoiceDetailsFunc(invoice.id);
        }
    }, [invoice?.id, location?.search]);

    useLayoutEffect(() => {
        if (!isDownload) return;

        const tableHeight = tableContainerRef.current?.offsetHeight || 0;
        const termsHeight = termsRef.current?.offsetHeight || 0;

        const PAGE_HEIGHT = 1120;   // px → fits your html2canvas scale
        const MARGIN_TOP = 40;      // top margin before table
        const GAP_BELOW_TABLE = 50; // spacing before terms

        const usedHeight = MARGIN_TOP + tableHeight + GAP_BELOW_TABLE;
        const remainingHeight = PAGE_HEIGHT - usedHeight;

        if (remainingHeight < termsHeight) {
            setPlaceTermsOnNextPage(true);
        } else {
            setPlaceTermsOnNextPage(false);
        }

    }, [isDownload, requests]);

    //  Detect redirect from Razorpay
    useEffect(() => {
        if (paymentStatus) {
            if (paymentStatus === "paid") {
                Popup.alert("Success", "Payment successful!", "SUCCESS");
            } else if (paymentStatus === "cancelled") {
                Popup.alert("Cancelled", "Payment was cancelled.", "INFO");
            } else if (paymentStatus === "failed") {
                Popup.alert("Failed", "Payment failed. Please try again.", "ERROR");
            }

            // Optionally clean URL after showing message
            setTimeout(() => {
                navigate("/leadInvoiceDetails", { state: { dsp, invoice }, replace: true });
            }, 300);
        }
    }, [paymentStatus]);

    const handleInvoicePayment = (invoice) => {
        try {
            // Ensure short_url exists
            if (!invoice?.razorpay_short_url) {
                Popup.alert("Error", "Payment link not available for this invoice.", "ERROR");
                return;
            }
            // 2️ Optionally you can log it
            console.log("Redirecting to Razorpay:", invoice?.razorpay_short_url);
            // 3️Redirect user to Razorpay checkout
            window.location.href = invoice?.razorpay_short_url;
        } catch (error) {
            console.error("Error redirecting to Razorpay:", error);
            Popup.alert("Error", "Unable to open payment page.", "ERROR");
        }
    };


    return (
        <div style={{ overflow: "auto", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: '20px' }}>
            {isDownload ? (
                <div style={{
                    position: 'relative',
                    top: '10px',
                    right: '-240px',
                    fontSize: '14px',
                }}>
                    Downloading...
                </div>
            ) : (
                <a
                    onClick={downloadPDF}
                    style={{
                        position: 'relative',
                        top: '10px',
                        right: '-240px',
                        textDecoration: 'underline',
                        color: '#007BFF',
                        cursor: 'pointer',
                        fontSize: '14px',
                    }}
                >
                    Download Invoice
                </a>
            )}
            <div className='myDiv' style={{ width: "620px" }}>
                <div style={{
                    width: '620px',
                    border: isDownload ? 'none' : '1px solid rgba(215, 218, 224, 0.4)',
                    borderRadius: '5px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    color: "#3B3B3B",
                    backgroundColor: '#fff',
                    paddingTop: isDownload ? "5px" : "0px"
                }}>

                    <div>
                        <div className="text-center" style={{ fontWeight: 700, marginTop: "20px", fontSize: "24px" }}>
                            <h1>Tax Invoice</h1>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            margin: '0px 30px',
                            padding: '20px 0px',
                            borderBottom: '1px solid rgba(215, 218, 224, 0.3)',
                        }}>
                            <div>
                                <img src={bhumeet} alt="bhumeet" width={"60px"} />
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <p style={{ margin: '0', fontSize: "13px", }}><span style={{ fontWeight: 600, color: "#1A1C21" }}>Invoice No.</span> - {settInvoice?.invoice_number || "-"}</p>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: "#727272",
                            padding: "20px 30px"
                        }}>
                            <div>
                                <div style={{ marginBottom: '20px' }}>
                                    <p style={{ margin: '0', fontWeight: 500 }}>From</p>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: "#1E1E1E" }}>{settInvoice?.from?.name}</p>
                                    <p style={{ margin: '0' }}>{settInvoice?.from?.address || '-'}</p>
                                    <p style={{ margin: '0' }}>{settInvoice?.from?.gstin || '-'}</p>
                                </div>
                                <div>
                                    <p style={{ margin: '0', fontWeight: 500 }}>To</p>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: "#1E1E1E" }}>{settInvoice?.to?.name || "-"}</p>
                                    {!settInvoice?.to?.address && !settInvoice?.dsp_city ?
                                        <p style={{ margin: '0' }}> - </p>
                                        :
                                        settInvoice?.to?.address ?
                                            <p style={{ margin: '0' }}>{settInvoice?.to?.address}</p>
                                            :
                                            settInvoice?.dsp_city ?
                                                <p style={{ margin: '0' }}>{settInvoice?.dsp_city}</p> : ""
                                    }
                                    {settInvoice?.dsp_gstin && (
                                        <p style={{ margin: '0' }}>GSTIN - {settInvoice?.dsp_gstin}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div style={{
                            borderTop: '1px solid rgba(215, 218, 224, 0.6)',
                            paddingTop: '10px',
                            margin: "10px 30px 30px"
                        }}>
                            <p style={{ margin: '0', fontSize: "14px", display: "flex", gap: "0.5rem" }}><span style={{ fontWeight: 600, color: "#5E6470" }}>Invoice Date - </span><span style={{ color: "#5E6470" }}>{dateFormat(settInvoice?.generated_time, "dd mmm yyyy")} </span>{" "}<span>{settInvoice?.generated_time?.toLocaleDateString('en-US', { weekday: 'long' })}</span></p>
                        </div>

                        <div style={{
                            backgroundColor: '#D9D9D9',
                            padding: '10px 25px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontWeight: 700,
                            color: '#1E1E1E',
                            height: "50px",
                            alignItems: "center",
                            fontSize: "18px",
                        }}>
                            <span>Lead Charges</span>
                            <span>Rates</span>
                        </div>

                        <div style={{ padding: '10px 30px 10px' }}>
                            {settInvoice?.total_amount > 0 && <div style={{ marginBottom: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500 }}>
                                    <div className="flex flex-col ">
                                        <div className="flex gap-2 items-center">
                                            <span>Total leads</span>
                                            {(settInvoice?.from_date && settInvoice?.to_date) && (
                                                <span className="text-[12px] font-600 text-gray-400">{`(From ${dateFormat(settInvoice?.from_date, "dd mmm yyyy")}  To  ${dateFormat(new Date(new Date(settInvoice?.to_date).getTime()), "dd mmm yyyy")} )`}</span>
                                            )}
                                        </div>
                                        {settInvoice.leads > 0 && (
                                            <span className="text-[13px] font-600 text-gray-400">{`(${Number(settInvoice?.leads)} leads X ₹${Number(settInvoice?.price_per_lead)} per lead)`}</span>
                                        )}
                                    </div>
                                    <span>₹ {formatToIndianRupees(settInvoice?.total_amount || 0)}</span>
                                </div>
                            </div>}
                            <img src={dashLine} alt="dashLine" style={{ maxWidth: "103%" }} />
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                fontWeight: 500
                            }}>

                                <span>Subtotal</span>
                                <span>₹ {formatToIndianRupees(settInvoice?.total_amount || 0)}</span>
                            </div>

                            {settInvoice?.gst_amount && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginTop: '10px',
                                    fontWeight: 500
                                }}>
                                    <div className="flex items-center">
                                        <span>GST</span>
                                        {" "}
                                        {settInvoice?.gst_percentage && (
                                            <span className="text-[12px] font-600 text-gray-400">{` (${Number(settInvoice?.gst_percentage)}% GST)`}</span>
                                        )}
                                    </div>
                                    <p> <span className="text-[14px]">+</span> ₹ {formatToIndianRupees(settInvoice?.gst_amount || 0)}</p>
                                </div>

                            )}

                            {settInvoice?.discount_amount != 0 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginTop: '10px',
                                    fontWeight: 500
                                }}>
                                    <div className="flex items-center">
                                        <span>Total Discount</span>
                                    </div>
                                    <p> <span className="text-[14px]">-</span> ₹ {formatToIndianRupees(settInvoice?.discount_amount || 0)}</p>
                                </div>

                            )}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingTop: '10px',
                                marginTop: '10px',
                                marginBottom: '30px',
                                fontWeight: 'bold',
                                borderTop: '1px solid rgba(215, 218, 224, 0.6)',
                                // borderBottom: '1px solid rgba(215, 218, 224, 0.6)',
                                paddingBottom: '10px',
                                fontSize: "18px",
                                marginBottom: isDownload ? "170px" : "0px"
                                // marginBottom: (isDownload && settInvoice?.invoice_type === DSP_INVOICES_TYPES.DEBIT_FOR_BHUMEET && (!settInvoice?.incentive_from_bhumeet_amount || settInvoice?.incentive_from_bhumeet_amount <= 0)) ? "80px" : isDownload && settInvoice?.invoice_type === DSP_INVOICES_TYPES.DEBIT_FOR_DSP ? "120px" : ""
                            }}>
                                <span>Total Amount</span>
                                <span>₹ {formatToIndianRupees((settInvoice?.total_amount_with_gst - settInvoice.discount_amount) || 0)}</span>
                            </div>
                            {
                                settInvoice?.status === SETTELEMENT_STATUSES.UNSETTLED && settInvoice?.razorpay_short_url && !user?.bhumeet_role && !settInvoice?.razorpay_payment_link_expired &&
                                (<div style={{ padding: '10px 30px 5px  30px', display: isDownload ? "none" : 'block' }}>

                                    <button
                                        className="settledButton"
                                        style={{
                                            backgroundColor: '#0f5eff',
                                            color: 'white',
                                            border: 'none',
                                            padding: '5px 20px',
                                            borderRadius: '5px',
                                            fontSize: '16px',
                                            cursor: settInvoice?.status === SETTELEMENT_STATUSES.SETTELED ? 'not-allowed' : 'pointer',
                                            width: '100%',
                                            opacity: settInvoice?.status === SETTELEMENT_STATUSES.SETTELED ? 0.5 : 1
                                        }}
                                        onClick={settInvoice?.status === SETTELEMENT_STATUSES.SETTELED ? () => { } : () => {
                                            handleInvoicePayment(settInvoice);
                                        }}
                                    >
                                        Pay Now
                                    </button>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
                {/* lead requests */}
                <div >
                    {settInvoice?.requestsChunks?.map((requestChunk, index) => {
                        return (
                            <div key={index} style={{
                                width: '620px',
                                marginTop: isDownload ? (index === 0 ? '30px' : '81px') : "40px",
                                border: '1px solid rgba(215, 218, 224, 0.4)',
                                borderRadius: isDownload ? "0px" : "5px",
                                boxShadow: isDownload ? "none" : "0 0 10px rgba(0,0,0,0.1)",
                                color: "#3B3B3B",
                                backgroundColor: '#fff'
                            }}>
                                <div className={`reusable-table-containar scroll-container`}>
                                    <div style={{
                                        fontWeight: "500",
                                        display: "flex",
                                        justifyContent: 'space-between',
                                    }}>
                                        <table className={`reusable-table-view`}>
                                            <thead style={{ width: "100%" }}>
                                                <tr className="reusable-table-view-header-row" style={{
                                                    height: isDownload ? "30px" : '45px',
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%"
                                                }}>
                                                    <th style={{ textAlign: "center", width: "30%", display: "inline-block", fontSize: isDownload ? "11px" : '12px', fontWeight: 600, color: "#1A1C21" }}>Request No.</th>
                                                    <th style={{ textAlign: "center", width: "40%", display: "inline-block", fontSize: isDownload ? "11px" : '12px', fontWeight: 600, color: "#1A1C21" }}>Date</th>
                                                    <th style={{ textAlign: "center", width: "30%", display: "inline-block", fontSize: isDownload ? "11px" : '12px', fontWeight: 600, color: "#1A1C21" }}>Lead Charges (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {requestChunk?.map((req, reqIndex) => {
                                                    return (
                                                        <>
                                                            <tr key={reqIndex} className="reusable-table-view-data-row" style={{
                                                                height: isDownload ? "30px" : '45px',
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                width: "100%"
                                                            }} align="center">
                                                                <td style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    height: "100%",
                                                                    border: "none",
                                                                    width: "30%",
                                                                }}
                                                                >
                                                                    {req.req_number}
                                                                </td>
                                                                <td style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    height: "100%",
                                                                    border: "none",
                                                                    width: "40%"
                                                                }}>
                                                                    {dateFormat(req.last_update, "dd mmm yyyy  HH:MM:ss TT")}
                                                                </td>
                                                                <td style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    height: "100%",
                                                                    border: "none",
                                                                    width: "30%"
                                                                }}>
                                                                    {formatToIndianRupees(settInvoice?.price_per_lead || req.price_per_lead || 100)}
                                                                </td>
                                                            </tr>
                                                            <hr></hr>
                                                        </>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {/* Terms & Conditions */}
                {isDownload && placeTermsOnNextPage && (
                    <div style={{ pageBreakBefore: "always" }}></div>
                )}
                <div
                    ref={termsWrapperRef}
                    style={{
                        width: '620px',
                        border: isDownload ? 'none' : '1px solid rgba(215,218,224,0.4)',
                        paddingTop: placeTermsOnNextPage ? "20px" : calculateTermsPadding(requests.length),
                        borderRadius: '5px',
                        boxShadow: isDownload ? 'none' : '0 0 10px rgba(0,0,0,0.1)',
                        backgroundColor: '#fff',
                        marginTop: '40px',
                        marginBottom: '20px',
                        padding: '20px 30px'
                    }}
                >
                    <h2 style={{ marginBottom: "5px", paddingBottom: "10px", color: "rgb(0,0,0)", fontSize: "12px", fontWeight: 700 }}>Terms & Conditions</h2>
                    <div style={{ color: "rgb(30,30,30)", fontWeight: 600, fontSize: "12px" }}>
                        <p>1. Leads are allocated monthly and must be used exclusively for drone spraying services.</p>
                        <p>2. Each completed lead is billed on a postpaid basis, regardless of acreage.</p>
                        <p>3. Lead Invoice are auto-generated every Wednesday and Saturday at midnight and can be paid through payment links.</p>
                        <p>4. If Invoice amounts are not paid within 15-day grace period lead access is suspended in immediate effective after the grace period expires.</p>
                        <p>5. Upon acceptance of a lead, all subsequent communication, scheduling, service execution, payment collection, and dispute resolution shall be solely managed by the DSP. BhuMeet shall not be liable for any operational, financial, or service-related matters post lead acceptance.</p>
                    </div>
                </div>
                <div>
                </div>
            </div >
        </div>
    )
}

export default DspLeadInvoiceDetails